import React from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import googleplay from "../asset/pngImage/googleplay.png";
import applestore from "../asset/pngImage/applestore.png";
import useSettings from "../hooks/useSettings";

export default function Footer() {
  const settings = useSettings();
  return (
    <footer className="footer">
      {/* Top trust bar */}
      <div className="footer-trust-bar">
        <div className="container">
          <div className="footer-trust-items">
            <div className="footer-trust-item">
              <i className="fa-solid fa-truck-fast"></i>
              <span>Free Shipping above ₹{settings?.pin_free_delivery ?? "2500"} in Delhi NCR</span>
            </div>
            <div className="footer-trust-item">
              <i className="fa-solid fa-shield-halved"></i>
              <span>100% Secure Payments</span>
            </div>
            <div className="footer-trust-item">
              <i className="fa-solid fa-leaf"></i>
              <span>Premium Quality Products</span>
            </div>
            <div className="footer-trust-item">
              <i className="fa-solid fa-rotate-left"></i>
              <span>Easy Returns & Refunds</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main footer body */}
      <div className="footer-main">
        <div className="container">
          <div className="row g-4">

            {/* Brand column */}
            <div className="col-lg-4 col-md-6">
              <h5 className="footer-heading">Zaya Dry Fruits</h5>
              <p className="footer-brand-desc">
                Premium quality dry fruits & nuts sourced directly from the finest farms. Taste the difference with every bite.
              </p>
              <div className="footer-contact-list">
                <div className="footer-contact-item">
                  <i className="fa-solid fa-location-dot"></i>
                  <span>G-8, Sector-18 Market, near Tanishq Jewellers, Noida, Uttar Pradesh 201301</span>
                </div>
                <div className="footer-contact-item">
                  <i className="fa-solid fa-envelope"></i>
                  <Link to="mailto:info@zayadryfruits.com" className="footer-link">info@zayadryfruits.com</Link>
                </div>
                <div className="footer-contact-item">
                  <i className="fa-solid fa-phone"></i>
                  <Link to="tel:+919958344409" className="footer-link">+(91) 99583 44409</Link>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 col-6">
              <h5 className="footer-heading">Quick Links</h5>
              <ul className="footer-links-list">
                <li><Link to="/#home" className="footer-link">Home</Link></li>
                <li><Link to="/about#about-us" className="footer-link">About Us</Link></li>
                <li><Link to="/contact#contact-us" className="footer-link">Contact Us</Link></li>
                <li><Link to="/FAQ#FAQ" className="footer-link">FAQ</Link></li>
                <li>
                  <Link to="/Khari-Baoli-Dry-Fruits-Rate-List-Today" className="footer-link">
                    Rate List
                  </Link>
                </li>
              </ul>
            </div>

            {/* Policies */}
            <div className="col-lg-2 col-md-6 col-6">
              <h5 className="footer-heading">Policies</h5>
              <ul className="footer-links-list">
                <li><Link to="/shipping&refundPolicy#shipping&refund-policy" className="footer-link">Shipping & Refund</Link></li>
                <li><Link to="/term&Condition#term-condition" className="footer-link">Terms & Conditions</Link></li>
                <li><Link to="/privacy-policy#privacy-policy" className="footer-link">Privacy Policy</Link></li>
              </ul>
            </div>

            {/* Social + App */}
            <div className="col-lg-4 col-md-6">
              <h5 className="footer-heading">Follow Us</h5>
              <div className="footer-social-icons">
                <Link to="https://www.facebook.com/ZayaDryFruits" target="_blank" className="footer-social-btn" aria-label="Facebook">
                  <i className="fa-brands fa-facebook-f"></i>
                </Link>
                <Link to="https://twitter.com/ZayaDryFruits" target="_blank" className="footer-social-btn" aria-label="Twitter">
                  <i className="fa-brands fa-twitter"></i>
                </Link>
                <Link to="https://www.instagram.com/zayadryfruits/" target="_blank" className="footer-social-btn" aria-label="Instagram">
                  <i className="fa-brands fa-instagram"></i>
                </Link>
                <Link to="https://in.pinterest.com/ZAYADryFruits/" target="_blank" className="footer-social-btn" aria-label="Pinterest">
                  <i className="fa-brands fa-pinterest-p"></i>
                </Link>
                <Link to="https://www.linkedin.com/company/zaya-dryfruits/" target="_blank" className="footer-social-btn" aria-label="LinkedIn">
                  <i className="fa-brands fa-linkedin-in"></i>
                </Link>
              </div>

              <h5 className="footer-heading" style={{ marginTop: "1.5rem" }}>Download Our App</h5>
              <div className="footer-app-buttons">
                <a href="https://play.google.com/store/apps/details?id=com.beaconcoders.zayadryfruits" target="_blank" rel="noreferrer">
                  <img src={googleplay} alt="Get it on Google Play" className="footer-app-img" />
                </a>
                <a href="https://apps.apple.com/in/app/zaya-dryfruits/id6478808117" target="_blank" rel="noreferrer">
                  <img src={applestore} alt="Download on App Store" className="footer-app-img" />
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-inner">
            <span>
              © {new Date().getFullYear()} Zaya Dryfruits. All Rights Reserved.
            </span>
            <span>
              Designed & Developed by{" "}
              <Link to="https://www.beaconcoders.com/" target="_blank" className="footer-link footer-dev-link">
                Beacon Coders
              </Link>
            </span>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
        toastStyle={{
          fontFamily: "'Work Sans', sans-serif",
          fontSize: "0.88rem",
          fontWeight: 600,
          borderRadius: "14px",
          boxShadow: "0 8px 32px rgba(130,93,55,0.18)",
          border: "1.5px solid #f0e0cc",
          color: "#2c1a0e",
          padding: "14px 16px",
        }}
        progressStyle={{ background: "linear-gradient(90deg, #825d37, #c4883a)" }}
      />
    </footer>
  );
}
